import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/shared/ScrollToTop";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import FocusAreasPage from "@/pages/FocusAreasPage";
import ProgramsPage from "@/pages/ProgramsPage";
import GetInvolvedPage from "@/pages/GetInvolvedPage";
import GovernancePage from "@/pages/GovernancePage";
import UpdatesPage from "@/pages/UpdatesPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/focus-areas" element={<FocusAreasPage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/get-involved" element={<GetInvolvedPage />} />
            <Route path="/governance" element={<GovernancePage />} />
            <Route path="/updates" element={<UpdatesPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
